import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiDart,  
  DiJavascript1,
  DiReact,
  DiNodejs,  
  DiPython,
  DiGit, 
  DiAndroid,
 
} from "react-icons/di";
import { 
  SiFlutter,
  SiFirebase, 
  SiSupabase,  
  SiMysql,
  SiTypescript,

  
} from "react-icons/si";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiDart />
      </Col>    
      <Col xs={4} md={2} className="tech-icons">
        <SiFlutter />
      </Col>    
      <Col xs={4} md={2} className="tech-icons">
        <DiAndroid />
      </Col>    
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>  
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>       
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>     
     
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSupabase />
      </Col>     
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>     
    </Row>
  );
}

export default Techstack;
